import { jsx } from "react/jsx-runtime";
import MoveToInboxIcon from "@mui/icons-material/MoveToInbox";
import { validateTidalLicense } from "../../base/index.js";
function MoveToInbox(props) {
  return /* @__PURE__ */ jsx(
    MoveToInboxIcon,
    {
      "data-testid": "MoveToInbox",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "MoveToInbox",
      "data-tidal-icon-meta": "mail,contact,calendar"
    }
  );
}
MoveToInbox.tidalIconMeta = {
  categories: "mail,contact,calendar",
  name: "MoveToInbox"
};
validateTidalLicense();
export {
  MoveToInbox
};
//# sourceMappingURL=MoveToInbox.js.map
